import { Component, Injector, Input, OnInit } from '@angular/core';
import { Asegurado } from 'src/app/Models/asegurado-detalle';
import { Seguro } from 'src/app/Models/seguro';
import { AppInsightsService } from 'src/app/Services/appInsight.service';
import { MesAnterior } from '../../Models/mes-anterior';

@Component({
  selector: 'app-kms-recorridos',
  templateUrl: './kms-recorridos.component.html',
  styleUrls: ['./kms-recorridos.component.css']
})
export class KmsRecorridosComponent implements OnInit {
  @Input()
  item: MesAnterior;
  isDataAvailable = true;
  asegurado: Asegurado;
  seguro: Seguro;

  constructor(private inj: Injector) {
   }
  ngOnInit(): void {
    if (this.item.totalKms === 0 || this.item.periodo == null){
      this.isDataAvailable = false;
    }
  }
  logEventVerViajes(): void{
    this.asegurado = JSON.parse(localStorage.getItem('asegurado'));
    this.seguro = JSON.parse(localStorage.getItem('miSeguro'));
    let fechaHoy = new Date();
    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.logEvent(`Click en boton ver viajes: (rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, Patente: ${this.seguro.poliza.patente}, Fecha Hora: ${fechaHoy.toString()})`);
  }
}
